export const STORAGE_KEYS = {
  ACTIVE_ORG_KEY: 'cf_active_org',
  TOKEN_KEY: 'cf_token',
  USER_KEY: 'cf_user',
  EXPIRY_KEY: 'cf_expiry',
  ORGS_KEY: 'cf_orgs',
  MASTER_DATA_KEY: 'cf_master_data',
} as const;
